import { Stack, Typography } from "@mui/material";
import { iconGap, perelynPrimary, smallerGap } from "../../styles/consts";

export default function ScoresInCommentPanel({ rating }) {
  const ratingCategories = ["CV", "Email", "Match"];
  const availableRatings = ratingCategories.filter(
    (category) => rating && rating[category] !== undefined
  );

  return (
    <Stack sx={{ flexDirection: "row", gap: smallerGap }}>
      {availableRatings.map((category, index) => (
        <Stack key={category} sx={{ flexDirection: "row", gap: iconGap }}>
          <Typography>{category}:</Typography>
          <Typography sx={{ color: perelynPrimary }}>
            {rating[category]}
          </Typography>
          {index < availableRatings.length - 1 && (
            <Typography sx={{ marginLeft: iconGap }}>|</Typography>
          )}
        </Stack>
      ))}
    </Stack>
  );
}
